import isHexColor from '@lib/isHexColor'
import clsx from 'clsx'
import { FC } from 'react'
import s from './Container.module.scss'

export type ContainerProps = {
  fluid?: boolean
  backgroundColor?: string
  className?: string
  color?: string
  children?: React.ReactNode
}

const Container: FC<ContainerProps> = ({
  backgroundColor,
  children,
  color,
  fluid,
  className,
  ...props
}) => {
  return (
    <div
      className={clsx(s.section, className)}
      style={{
        backgroundColor: isHexColor(backgroundColor)
          ? backgroundColor
          : `#${backgroundColor}`,
        color: isHexColor(color) ? color : `#${color}`,
      }}
      {...props}
    >
      <div className={clsx(s.container, { [s.fluid]: fluid })}>{children}</div>
    </div>
  )
}

export default Container
